/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './patient-procedure-episode.reducer';

export const PatientProcedureEpisode = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const patientProcedureEpisodeList = useAppSelector(state => state.patientProcedureEpisode.entities);
  const loading = useAppSelector(state => state.patientProcedureEpisode.loading);
  const totalItems = useAppSelector(state => state.patientProcedureEpisode.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="patient-procedure-episode-heading" data-cy="PatientProcedureEpisodeHeading">
        <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.home.title">Patient Procedure Episodes</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/patient-procedure-episode/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.home.createLabel">
              Create new Patient Procedure Episode
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.patientProcedureEpisode.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {patientProcedureEpisodeList && patientProcedureEpisodeList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('plannedStart')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.plannedStart">Planned Start</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plannedStart')} />
                </th>
                <th className="hand" onClick={sort('plannedEnd')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.plannedEnd">Planned End</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('plannedEnd')} />
                </th>
                <th className="hand" onClick={sort('actualStart')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.actualStart">Actual Start</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actualStart')} />
                </th>
                <th className="hand" onClick={sort('actualEnd')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.actualEnd">Actual End</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('actualEnd')} />
                </th>
                <th className="hand" onClick={sort('outcome')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.outcome">Outcome</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('outcome')} />
                </th>
                <th className="hand" onClick={sort('notes')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.notes">Notes</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('notes')} />
                </th>
                <th className="hand" onClick={sort('status')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.status">Status</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('status')} />
                </th>
                <th className="hand" onClick={sort('statusReason')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.statusReason">Status Reason</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('statusReason')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.procedure">Procedure</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.metaEpisode">Meta Episode</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {patientProcedureEpisodeList.map((patientProcedureEpisode, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/patient-procedure-episode/${patientProcedureEpisode.id}`} color="link" size="sm">
                      {patientProcedureEpisode.id}
                    </Button>
                  </td>
                  <td>{patientProcedureEpisode.plannedStart}</td>
                  <td>{patientProcedureEpisode.plannedEnd}</td>
                  <td>{patientProcedureEpisode.actualStart}</td>
                  <td>{patientProcedureEpisode.actualEnd}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ProcedureOutcome.${patientProcedureEpisode.outcome}`} />
                  </td>
                  <td>{patientProcedureEpisode.notes}</td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ProcedureStatus.${patientProcedureEpisode.status}`} />
                  </td>
                  <td>
                    <Translate contentKey={`tinyMedicRestApp.ProcedureStatusReason.${patientProcedureEpisode.statusReason}`} />
                  </td>
                  <td>{patientProcedureEpisode.active ? 'true' : 'false'}</td>
                  <td>{patientProcedureEpisode.cursor}</td>
                  <td>{patientProcedureEpisode.lastUpdated}</td>
                  <td>{patientProcedureEpisode.microSec}</td>
                  <td>{patientProcedureEpisode.timestampEntry}</td>
                  <td>
                    {patientProcedureEpisode.procedure ? (
                      <Link to={`/patient-procedure/${patientProcedureEpisode.procedure.id}`}>{patientProcedureEpisode.procedure.id}</Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {patientProcedureEpisode.metaEpisode ? (
                      <Link to={`/procedure-episode/${patientProcedureEpisode.metaEpisode.id}`}>
                        {patientProcedureEpisode.metaEpisode.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/patient-procedure-episode/${patientProcedureEpisode.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/patient-procedure-episode/${patientProcedureEpisode.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/patient-procedure-episode/${patientProcedureEpisode.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.patientProcedureEpisode.home.notFound">No Patient Procedure Episodes found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={patientProcedureEpisodeList && patientProcedureEpisodeList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default PatientProcedureEpisode;
